import { FC } from 'react'
import { Sensors } from './components/Sensors'

const SensorsPage: FC = () => {
  return (
    <Sensors />
  );
}

export {SensorsPage}